import {AxiosRequestConfig} from 'axios';
import {SkillService} from './skill.service';
import Logger from '../../logger';
import {getAuthToken} from '../../utils';
import {APIServiceImpl, ServiceResponse} from '../api';
import {Skill} from '../../models';
import {CreateSkillParams, GetSkillsParams} from './skill-params';

export class SkillServiceImpl extends APIServiceImpl implements SkillService {
  static readonly CREATE_SKILL = '/skills';
  static readonly GET_SKILLS = '/skills';

  constructor() {
    super();
    this.service.interceptors.request.use((request): AxiosRequestConfig => {
      const token = getAuthToken();
      token && (request.headers.Authorization = `Bearer ${token}`);
      return request;
    });
  }

  async createSkill(params: CreateSkillParams): Promise<ServiceResponse<Skill>> {
    try {
      const {data: res} = await this.post(SkillServiceImpl.CREATE_SKILL, params);
      return new ServiceResponse<Skill>(res);
    } catch (e) {
      const error = e.response?.data?.message || e.message || e.response?.status;
      Logger.error(`POST ${SkillServiceImpl.CREATE_SKILL} ${JSON.stringify(params)}: ${e.toString()}: ${error}`);
      return new ServiceResponse<Skill>(undefined, error);
    }
  }

  async getSkills(params: GetSkillsParams): Promise<ServiceResponse<Skill[]>> {
    try {
      const config: AxiosRequestConfig = {
        params: {
          pageNumber: params.page,
          pageSize: params.size,
          search: params.search,
        },
      };

      const {data: res} = await this.get(SkillServiceImpl.GET_SKILLS, config);
      return new ServiceResponse<Skill[]>(res);
    } catch (e) {
      const error = e.response?.data?.message || e.message || e.response?.status;
      Logger.error(`GET ${SkillServiceImpl.GET_SKILLS}: ${e.toString()}: ${error}`);
      return new ServiceResponse<Skill[]>(undefined, error);
    }
  }
}
